module.exports = __webpack_public_path__ + "static/media/keizoku_guide.drawio.b2653765.svg";